import script from "./QuoteGeneratorEmbedded.vue?vue&type=script&setup=true&lang=js"
export * from "./QuoteGeneratorEmbedded.vue?vue&type=script&setup=true&lang=js"

import "./QuoteGeneratorEmbedded.vue?vue&type=style&index=0&id=7d89fd24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d89fd24"]])

export default __exports__